/**
 * PageLoader.jsx — Indicateur de chargement de page
 *
 * ============================================================
 * 📚 LEÇON : Rôle du fallback Suspense
 * ============================================================
 *
 * Ce composant s'affiche pendant qu'un chunk lazy est en cours
 * de téléchargement. Sans lui, l'utilisateur verrait une page
 * blanche pendant 100-300ms — très mauvais pour l'UX.
 *
 * Bonne pratique : le fallback doit ressembler à la page finale
 * pour éviter le "layout shift" (saut visuel). Ici on utilise
 * le fond et les couleurs du thème pour une transition douce.
 *
 * ============================================================
 */

import React from 'react'
import styles from './PageLoader.module.css'

/**
 * Composant Atome : PageLoader
 *
 * Spinner centré affiché en fallback des routes lazy-loadées.
 * Utilise les variables CSS du thème pour s'adapter au mode clair/sombre.
 *
 * @component
 * @example
 * // Utilisé automatiquement par Suspense dans App.jsx
 * <Suspense fallback={<PageLoader />}>
 *   <MonComposantLazy />
 * </Suspense>
 */
const PageLoader = () => {
  return (
    <div className={styles.container} role="status" aria-label="Chargement de la page">
      <div className={styles.spinner}>
        {/* Anneau extérieur animé */}
        <div className={styles.ring} />
        {/* Logo centré pour branding pendant le chargement */}
        <img
          src="/common/burdigala-logo-small.webp"
          alt=""
          className={styles.logo}
          aria-hidden="true"
        />
      </div>
      <p className={styles.text}>Chargement…</p>
    </div>
  )
}

export default PageLoader
